export default {
  title: 'Galería',
  sections: {
    logo: 'Logo',
    web_images: 'Imágenes de galería para pedidos online',
  },
  toasts: {
    image_uploaded: 'Cambios guardados correctamente',
    image_upload_failed: 'Error al guardar los cambios',
  },
};
